import axios from "axios";
import { PASSPORT_SUBMENU_PRIVILLAGE_REQUEST, PASSPORT_SUBMENU_PRIVILLAGE_SUCCESS, SUBMENU_PRIVILLAGE_REQUEST, SUBMENU_PRIVILLAGE_SUCCESS } from "../constants/subMenuPrivillageConstants";

// checkSubMenuPrivillage
export const checkSubMenuPrivillage = (roleId) => async (dispatch, getState) => {
  try {

    dispatch({ type: SUBMENU_PRIVILLAGE_REQUEST });

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`
      }
    };

    const body = {
      approval1: "B2B Duplicate lead approval",
      approval2: "Duplicate lead approval",
      approval3: "Owner change approval",
      approval4: "Lead details edit approval",
      approval5: "Lead status approval",
      approval6: "Enrollment approval"
    };

    let { data } = await axios.post(`api/admin/privillage/submenuprivillage?roleId=${roleId}`, body, config)

    dispatch({ type: SUBMENU_PRIVILLAGE_SUCCESS, payload: data });

  } catch (error) {
    console.error(error);
  }
}

export const checkPassportSubMenuPrivillage = (roleId) => async (dispatch, getState) => {
  try {

    dispatch({ type: PASSPORT_SUBMENU_PRIVILLAGE_REQUEST });    

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`
      }
    };

    const body = {
      approval1: "Lead passport verify approval",
      approval2: "Lead passport edit approval",
    };

    let { data } = await axios.post(`api/admin/privillage/passportsubmenuprivillage?roleId=${roleId}`, body, config)

    dispatch({ type: PASSPORT_SUBMENU_PRIVILLAGE_SUCCESS, payload: data });

  } catch(error) {
    console.error(error);
  }
}
